import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, reactive, toRaw } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import CosLayoutMain from '@/components/CosLayoutMain/index.vue'
import BusinessForm from './components/BusinessForm.vue'
import { goBack } from '@/hooks/cosRouter'
import { businessCreateOrEdit } from '@/api/overseasSales/chanceManage'
import type { FbuBusinessEditParams } from '@/typings/api/chanceManage'

const __default__ = { name: 'DcCosOFbuBusinessAdd' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const { t } = useI18n()

const dataForm = reactive<FbuBusinessEditParams>({})

// 赋值url参数到dataForm
const saleChanceRefId = ref<boolean>()
const arkCodeId = ref<boolean>()
const isFromPotentialCustomer = ref<boolean>() // 是否线索转潜客
if (route.query.saleChanceRefId) {
  dataForm.saleChanceRefId = route.query.saleChanceRefId as string
  saleChanceRefId.value = true
}
if (route.query.arkCodeId) {
  dataForm.arkCodeId = parseInt(route.query.arkCodeId as string)
  arkCodeId.value = true
}
if (route.query.isFromPotentialCustomer) {
  dataForm.isFromPotentialCustomer = true
  isFromPotentialCustomer.value = true
}

const fetch = (val: any) => {
  Object.assign(dataForm, val)
}

const businessFormRef = ref()
const handleReset = () => {
  businessFormRef.value?.resetFields()
}
const loading = ref(false)
const handleSubmit = () => {
  businessFormRef.value?.validate().then(async () => {
    try {
      loading.value = true
      const params = toRaw(dataForm)
      await businessCreateOrEdit(params)
        .then(() => {
          message.success(isFromPotentialCustomer.value ? t('business.ml0kum') : t('business.wvw17m'))
          businessFormRef.value?.resetFields()
          goBack()
        })
        .finally(() => {
          loading.value = false
        })
    } catch (e) {
      loading.value = false
      console.log(e)
    }
  }).catch((error: any) => {
    console.log(error)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(CosLayoutMain, null, {
    content: _withCtx(() => [
      _createVNode(BusinessForm, {
        ref_key: "businessFormRef",
        ref: businessFormRef,
        title: _unref(t)('business.luzk2t'),
        type: "add",
        value: dataForm,
        "onUpdate:value": [
          _cache[0] || (_cache[0] = ($event: any) => ((dataForm) = $event)),
          fetch
        ],
        saleChanceRefId: saleChanceRefId.value,
        arkCodeId: arkCodeId.value,
        isFromPotentialCustomer: isFromPotentialCustomer.value
      }, null, 8, ["title", "value", "saleChanceRefId", "arkCodeId", "isFromPotentialCustomer"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goBack)()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('btn.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_button, {
        loading: loading.value,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (handleReset()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('btn.reset')), 1)
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_a_button, {
        type: "primary",
        loading: loading.value,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (handleSubmit()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('btn.save')), 1)
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }))
}
}

})